/**
 * Liste des pays pour les formulaires (newsletter, alumni).
 * Utilise le package country-list (ISO 3166-1).
 * Retourne { code, name }[] trié par nom.
 */
import { getData } from 'country-list';

function getCountriesSync() {
  return getData()
    .map((c) => ({ code: c.code, name: c.name }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

/** Retourne une promesse résolue avec la liste des pays (compatibilité avec l’appel async). */
export function getCountries() {
  return Promise.resolve(getCountriesSync());
}

export function clearCountriesCache() {
  // Pas de cache côté client avec le package
}
